export default {
    trends: {
        alternative: 'Use the trend finder to add micro- and macro-trends to your work space.',
        action: 'Trend finder'
    },
    exportTooltip: 'Export work space',
    title: 'Work space',
    pageTitle: 'VIEW - WORK SPACE'
}
